<template>
  <div class="about">
    <h1>This is an about page</h1>
  </div>
</template>

<script src="./About.js"></script>
<style lang="scss" src="./About.scss"></style>
